import * as H from 'history'

import { Client, Container } from 'types/api/attacks/client'
import {
  AttackCommand,
  AttackConfiguration
} from 'types/api/attacks/details/targeting'
import { K8sClient, K8sObject } from 'types/api/kubernetes/kubernetes'
import { Metadata } from 'types/metadata'

export type CreateAttackStage = 'selectTarget' | 'target' | 'impact' | 'trigger'

export enum TargetType {
  Hosts = 'Hosts',
  Containers = 'Containers',
  Kubernetes = 'Kubernetes',
  Application = 'Applications',
  Services = 'Services'
}

export type TargetingStrategy = 'EXACT' | 'RANDOM'

export type Target = K8sObject | Container | Client

export enum ProvenanceTargetType {
  ProcessData = 'Host',
  Container = 'Container',
  Kubernetes = 'Kubernetes',
  // The following enums are to support legacy references to target type
  // TODO: These should look to be removed throughout the app
  PROCESSDATA = 'Host',
  CONTAINER = 'Container',
  KUBERNETES = 'Kubernetes'
}

export type AttackFormOnSubmit = (
  targetType: TargetType,
  params: Record<string, any>,
  metadata: Record<string, any>[],
  currentTeamId: string,
  history: H.History,
  meta: Record<string, any>
) => void

export interface AttackFormProps {
  activeStage: CreateAttackStage
  cancelButtonText?: string
  displayGremlinImpact?: boolean
  displayScheduling?: boolean
  displayTargeting?: boolean
  displayTargetingImpact?: boolean
  expandAllStages?: boolean
  forcedAttackCommand?: AttackCommand
  infraClients: Client[]
  infraMetadata: Metadata
  infraProviders: Record<string, any>[]
  isLoading: boolean
  isScenario?: boolean

  onCancel(
    targetType: TargetType,
    params: Record<string, any>,
    metadata: Record<string, any>[],
    currentTeamId: string,
    history: H.History,
    meta: Record<string, any>
  ): void

  onSubmit: AttackFormOnSubmit
  submitButtonText?: string
  targetType: TargetType

  updateActiveStage(stage: CreateAttackStage): void

  serviceId?: string
}

export type InfraTargetType = TargetType.Hosts | TargetType.Containers

export interface InfraAttackFormProps extends AttackFormProps {
  infraAttackParams: Record<string, any>
  targetType: InfraTargetType
}

export type KubernetesTargetType = TargetType.Kubernetes

export interface KubernetesAttackFormProps extends AttackFormProps {
  attackParams: Record<string, any>
  isK8ClientsLoading: boolean
  k8sClientsRaw: K8sClient[]
  targetType: KubernetesTargetType
}

export interface CreateServiceAttackProps
  extends Partial<KubernetesAttackFormProps> {
  lastStep: Record<string, any>

  onScenarioServicesSubmit(
    targetType: TargetType,
    params: Record<string, any>,
    metadata: Record<string, any>[],
    currentTeamId: string,
    history: H.History,
    meta: Record<string, any>,
    requestBody: AttackConfiguration
  ): void
}
